import { Paper, Stack, Text } from '@mantine/core';
import React from 'react';
// import { NonCollapsibleWithVirtualizedTable } from '../../../../../../react-commons/components/data-display/NonCollapsibleVirtualizedTable';
import { BackgroundValidatedExportTaskResult } from '../../../../resource/services/backgroundTaskResource';
import { DependencyValidationResultComponent } from './DependencyValidationResultComponent';

export const ValidatedExportResultComponent = ({ validatedExportTaskResult }: {
    validatedExportTaskResult: BackgroundValidatedExportTaskResult;
}) => {
    return (
        <Stack>
            {validatedExportTaskResult.validationResultSet && (
                <div style={{ display: 'inline-flex', width: '100%' }}>
                    <Text style={{ minWidth: 200 }}>Validation Result</Text>
                    <Paper withBorder style={{ width: '100%' }}>
                        <DependencyValidationResultComponent
                            dependencyValidationResult={validatedExportTaskResult.validationResultSet}
                            height={550}
                        />
                    </Paper>
                </div>
            )}
            {/*{validatedExportTaskResult.exceptionMessages && (*/}
            {/*    <NonCollapsibleWithVirtualizedTable*/}
            {/*        disabled={false}*/}
            {/*        maxRowsDisplayed={15}*/}
            {/*        columnData={[*/}
            {/*            {*/}
            {/*                width: 500,*/}
            {/*                label: 'Exception messages',*/}
            {/*                dataKey: 'exceptions',*/}
            {/*            },*/}
            {/*        ]}*/}
            {/*        rows={validatedExportTaskResult.exceptionMessages.map((value) => ({*/}
            {/*            exceptions: <ControlledInputs.String nullable={false} value={value} readOnly={true} />,*/}
            {/*        }))}*/}
            {/*    />*/}
            {/*)}*/}
        </Stack>
    );
};


